import React from "react";
import { Form, Row, Col, Container } from "react-bootstrap";
import RangeSlider from "react-bootstrap-range-slider";
import EntityDetail from "./EntityDetail";
import Specialization from "./Specialization";
import PointOfService from "./PointOfService";
import Button from "react-bootstrap/Button";
import { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { AppContext } from "../context/AppContext";
import { useContext } from "react";
import oService from "../services/onboarding.service";
import { useNavigate } from "react-router-dom";
let captchaValue;

function Onboarding() {
  const [setLoaderActive, toast] = useContext(AppContext);
  const [validated, setValidated] = useState(false);
  const [formInputData, setFormInputData] = useState({
    bpName: "",
    lob_id: "",
    user_type_id: "",
    firstName: "",
    lastName: "",
    mobile: "9038647079",
    mobileVerified: false,
    email: "gauravsingh.8026@gmail.com",
    emailVerified: false,
    address: {},
    specialities: [],
    posds: [],
    tenure: "3",
  });
  const navigate = useNavigate();
  const addressRef = useRef();
  const mobileRef = useRef();
  const emailRef = useRef();
  const handleInputChange = (evnt) => {
    const inputFieldValue = evnt.target.value;
    const inputFieldName = evnt.target.name;

    if (inputFieldName === "speciality") {
      if (!evnt.target.checked) {
        let index = formInputData.specialities.indexOf(inputFieldValue);
        formInputData.specialities.splice(index, 1);
      } else {
        formInputData.specialities.push(inputFieldValue);
      }

      setFormInputData({ ...formInputData });
      return true;
    }

    if (inputFieldName === "posd") {
      if (!evnt.target.checked) {
        let index = formInputData.posds.indexOf(inputFieldValue);
        formInputData.posds.splice(index, 1);
      } else {
        formInputData.posds.push(inputFieldValue);
      }

      setFormInputData({ ...formInputData });
      return true;
    }
    const NewInputValue = {
      ...formInputData,
      [inputFieldName]: inputFieldValue,
    };
    setFormInputData(NewInputValue);
  };

  const handleSubmit = async (event) => {
    console.log(addressRef.current.value);
    event.preventDefault();
    const form = event.currentTarget;
    let error = false;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      error = true;
    }
    setValidated(true);

    const mobileData = mobileRef.current.value;
    const emailData = emailRef.current.value;

    // captcha test

    if (!mobileData.mobileVerified) {
      toast.error("Mobile number is not verified");
      error = true;
    }

    if (!emailData.emailVerified) {
      toast.error("Email Address is not verified");
      error = true;
    }

    if (captchaValue == null) {
      toast.error("Please complete captcha.");
      error = true;
    }
    if (!error) {
      setLoaderActive(true);
      const captchaResult = await oService.captchaVerify(captchaValue);
      if (!captchaResult) {
        setLoaderActive(false);
        error = true;
        toast.error("Captcha verification failed");
      }
    }

    if (error) return false;

    const response = await oService.completeOnboarding({
      ...formInputData,
      ...mobileData,
      ...emailData,
      address: addressRef.current.value,
    });
    response && toast.success("Registration Completed!");
    setLoaderActive(false);
    response && navigate("/auth/login");
    return false;
  };

  const handleCaptcha = (value) => {
    // console.log("Captcha value:", value);
    captchaValue = value;
  };
  return (
    <Container>
      <h1 className="text-center">KAPID Partner Registration</h1>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <EntityDetail
          formInputData={formInputData}
          setFormInputData={setFormInputData}
          handleInputChange={handleInputChange}
          addressRef={addressRef}
          mobileRef={mobileRef}
          emailRef={emailRef}
        />
        <PointOfService
          formInputData={formInputData}
          handleInputChange={handleInputChange}
        />
        <Specialization
          formInputData={formInputData}
          handleInputChange={handleInputChange}
        />

        <div className="d-md-flex justify-content-between mb-3">
          <Form.Group>
            <Form.Label>Contract Duration</Form.Label>
            <RangeSlider
              name="tenure"
              value={formInputData.tenure}
              onChange={handleInputChange}
              min={5}
              max={10}
              step={1}
              tooltipLabel={(currentValue) =>
                currentValue === 1
                  ? `${currentValue} Year`
                  : `${currentValue} Years`
              }
              tooltip="on"
              tooltipPlacement="bottom"
            />
          </Form.Group>
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_CLIENT_KEY}
            onChange={handleCaptcha}
          />
          <Form.Group>
            <Button type="submit" variant="success">
              Submit
            </Button>
          </Form.Group>
        </div>
      </Form>
    </Container>
  );
}

export default Onboarding;
